// 3rd party
import React, { ReactElement } from 'react';

// Components
import { CartFulfillmentDetails } from 'components';

// Types
import { CartOrderDetails } from 'types/parts/cart';

interface Props {
  handleUpdate: (orderDetails: CartOrderDetails) => void;
  orderDetails: CartOrderDetails;
  isUrgent?: boolean
}
const CartStepTwo = ({ orderDetails, handleUpdate, isUrgent }: Props): ReactElement => {
  return <CartFulfillmentDetails isUrgent={isUrgent} orderDetails={orderDetails} handleUpdate={handleUpdate} />;
};

export default CartStepTwo;
